import axios from 'axios'
// import Download from './download-signatures.service'
class SignatureTypesService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Gustavo Adolfo Pacheco Cruz
  * @description 
  * @date 11-01-2021
  * @param {String} token
  * @param {Object} address
  * @returns {Object}
  * @memberof 
  */
  async getSignatureTypes(token) {
    let response = await axios.get(`${this.apiUrl}/signature-types`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
    // let download = new Download(this.apiUrl)
    // let result = await download.getSignatures(token);
    // let { filePrivateKey, fileCertificate, filePublicKey } = result
    // let files = [{
    //   file: new Uint8Array(filePrivateKey.data.data),
    //   name: filePrivateKey.name
    // }, {
    //   file: new Uint8Array(fileCertificate.data.data),
    //   name: fileCertificate.name
    // }, {
    //   file: new Uint8Array(filePublicKey.data.data),
    //   name: filePublicKey.name
    // }]
    // files.forEach(item => {
    //   let blob = new Blob([item.file], { type: 'application/octet-binary' })
    //   let link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = item.name;
    //   link.click();
    // })
    return response.data.data
  }



}

export { SignatureTypesService as default }